export enum FormFieldLabel {
  RESULT_SIGNIFICANCE = 'Result Significance',
  TEST_RESULTS = 'Test Results'
}
